import axios from '../axios';

class User{
    constructor() {
        this.reset_password = '/user/reset_password';
        this.reset_password_token = '/user/reset_password/:token/';
        this.list = '/user/list';
        this.user = '/user/';
        this.userDetail = '/user/:id/';
    }
    resetPassword(params) {
        return axios(this.reset_password, { method: 'post', params });
    }
    resetPasswordByToken(params) {
        return axios(this.reset_password_token, { method: 'post', params });
    }
    getList(params) {
        return axios(this.list, { method: 'get', params });
    }
    getUserDetail(params) {
        return axios(this.userDetail, { method: 'get', params });
    }
    putUserDetail(params) {
        return axios(this.userDetail, { method: 'put', params });
    }
    createUser(params) {
        return axios(this.user, { method: 'post', params });
    }
};
export default new User();



// WEBPACK FOOTER //
// ./src/api/modules/user.js